export default __webpack_public_path__ + "static/celestia-logo-white-bae3ea10400f9b7ea25d246e3d60d16d.svg";